import React from "react";
import { LayoutTypes, useLayoutType } from "@/util-react/layout";
import { MostBoughtDesktop } from "@/elements-react/most-bought/most-bought.desktop";
import { MostBoughtMobile } from "@/elements-react/most-bought/most-bought.mobile";

const getPageComponent = (layoutType: LayoutTypes) => {
  switch (layoutType) {
    case LayoutTypes.TYPE_DESKTOP:
      return MostBoughtDesktop;
    case LayoutTypes.TYPE_MOBILE:
      return MostBoughtMobile;
  }
};

export const MostBought: React.FC = () => {
  const { layoutType } = useLayoutType();
  const PageComponent = getPageComponent(layoutType);

  return <PageComponent />;
};
